import script from "./UserAccountSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccountSettings.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/user/UserAccountSettings.css?vue&type=style&index=0&id=04ce1887&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ce1887"]])

export default __exports__